export default __webpack_public_path__ + "static/media/sponsor-medina-firula-mobile.2938dd05.png";